import { TOTP_PROVIDER_AMPLITUDE_EVENT } from '../../constants';
import AmplitudeUtils from '../../utils/amplitude-utils';
import React from 'react';
import BaseForgeCustomizer from '../base-forge';
import ProxyButton from '../../components/common/ProxyButton';
import AppDownloadInstructions from '../../components/enroll-totp/AppDownloadInstructions';

export default class EnrollTotpCustomizer extends BaseForgeCustomizer {
  displayFooterText = true;

  async shouldCustomize() {
    return [ 'enroll-totp' ].includes(this.context?.controller);
  }

  protected forgifyController() {
    AmplitudeUtils.logMfaEnrollEvent(`${TOTP_PROVIDER_AMPLITUDE_EVENT['OKTA']}TotpEnroll::Landing`);
    super.forgifyController();
    this.forgifyNextButton();
    this.forgifyAppDownloadInstructions();
  }

  private forgifyNextButton() {
    const oktaNextButton: JQuery<HTMLElement> = jQueryCourage('.link-button');
    if (oktaNextButton.length) {
      const forgeComponent = (
        <ProxyButton
          oktaButton={oktaNextButton}
          variant="primary"
          fullWidth
          size="large"
          className="fe_u_margin--bottom-medium"
        />
      );
      this.renderForgeAndHideOktaComponent({
        id: oktaNextButton.attr('class')!,
        oktaComponent: oktaNextButton,
        forgeComponent: forgeComponent,
      });
    }
  }
  private forgifyAppDownloadInstructions() {
    const oktaAppDownloadInstructions: JQuery<HTMLElement> = jQueryCourage('.app-download-instructions');
    if (oktaAppDownloadInstructions.length) {
      const forgeComponent = <AppDownloadInstructions container={oktaAppDownloadInstructions} />;
      this.renderForgeAndHideOktaComponent({
        id: oktaAppDownloadInstructions.attr('class')!,
        oktaComponent: oktaAppDownloadInstructions,
        forgeComponent: forgeComponent,
      });
    }
  }
}
